export default __webpack_public_path__ + "static/media/swissmarketsDemo_downloadMT4.e6dafe48.png";